import breakfast from "../assets/breakfast.png";
import coldDrinks from "../assets/colddrinks.png";
import dinner from "../assets/dinner.png";
import lunch from "../assets/lunch.png";
import momo from "../assets/momo.png";
import special from "../assets/special.png";
import bakery from "../assets/bakery.png";
import biriyani from "../assets/biriyani.png";
import sweet from "../assets/sweet.webp";
import noodles from "../assets/noodles.webp";

import chickenSekuwa from "../assets/chicken-sekuwa.jpg";
import cookermomo from "../assets/cooker-momo.jpg";
import muttonKhanaSet from "../assets/mutton-khana-set.jpg";

export const menuCategories = [
	{
		title: "Entrée",
		url: "/menu-list/Entrée",
		image: breakfast,
	},
	{
		title: "Rice and Curry",
		url: "/menu-list/Rice_and_Curry",
		image: lunch,
	},
	{
		title: "Fried Rice & Kottu",
		url: "/menu-list/Fried_Rice_And_Kottu",
		image: special,
	},
	{
		title: "Nasi Goreng",
		url: "/menu-list/Nasi_Goreng",
		image: momo,
	},
	{
		title: "Biriyani",
		url: "/menu-list/Biriyani",
		image: biriyani,
	},
	{
		title: "Noodles",
		url: "/menu-list/Noodles",
		image: noodles,
	},
	{
		title: "Hoppers & String Hoppers",
		url: "/menu-list/Hoppers_and_String_Hoppers",
		image: dinner,
	},
	{
		title: "Roti & Paratha",
		url: "/menu-list/Roti_and_Paratha",
		image: momo,
	},
	{
		title: "Kamatha Special Devilled",
		url: "/menu-list/Kamatha_Special_Devilled",
		image: momo,
	},
	{
		title: "Curries",
		url: "/menu-list/Curries",
		image: lunch,
	},
	{
		title: "Bakery Items",
		url: "/menu-list/Bakery_Items",
		image: bakery,
	},
	{
		title: "Drinks",
		url: "/menu-list/drinks",
		image: coldDrinks,
	},
	{
		title: "Sri lankan Sweets & Desserts",
		url: "/menu-list/Sri_Lankan_Sweeets_and_Desserts",
		image: sweet,
	},
];

export const chefsRecommendations = [
	{
		name: "Sri Lankan special Dolphin Kottu ",
		price: 23,
		description: "Special kottu (Chicken / Lamb / Pork / Fish / Prawn)",
		photo: muttonKhanaSet,
	},
	{
		name: "Crab Curry",
		price: 26 ,
		description: "Special Crab curry",
		photo: cookermomo,
	},
	{
		name: "Yellow Rice and curry",
		price: 18,
		description: "Yellow rice with 4 items",
		photo: chickenSekuwa,
	},
];


export const menuItems = {
	Entrée: [
		{
			title: "Cuttles",
			price: "$ 2.50 ",
			// tags: "AU | Bottle",
		},
		{
			title: "Patties",
			price: "$ 3.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Pastries",
			price: "$ 2.50",
			// tags: "FR | 750 ml",
		},
		{
			title: "Rolls",
			price: "$ 2.50",
			// tags: "CA | 750 ml",
		},
	],

Rice_and_Curry: [
		{
			title: "White rice 1 meat with 3 vegetables",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Yellow rice 1 meat with 3 vegetables",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Red rice 1 meat with 3 vegetables",
			price: "$ 18.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Lamprais - Chicken",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lamprais - Lamb",
			price: "$ 23.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Lamprais - Fish",
			price: "$ 23.00",
			// tags: "IE | 750 ml",
		}
	],

Kamatha_Special_Devilled : [
		{
			title: "Chicken",
			price: "$ 12.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Chicken (Large)",
			price: "$ 23.50",
			// tags: "AU | Bottle",
		},
		{
			title: "Pepper Dishes (Chicken/Lamb/Pork)",
			price: "$ 13.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Pepper Dishes (Large)",
			price: "$ 26.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Fish",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Fish (Large)",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lamb",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lamb (Large)",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Pork)",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Pork (Large)",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Prawn",
			price: "$ 30.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Hot Butter Cuttlefish (Dry/Gravy)",
			price: "$ 28.00",
			// tags: "FR | 750 ml",
		},
		
	],

Fried_Rice_And_Kottu : [

		{
			title: "Fried Rice (Chicken/Lamb/Pork/Fish/Egg)",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Seafood Fried Rice (Fish ,Prawns & Squid",
			price: "$ 23.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Mix Seafood Fried Rise (Seafood & Chicken)",
			price: "$ 25.00",
			// tags: "FR | 750 ml",
		},

		{
			title: "Vegetable Kottu",
			price: "$ 18.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Chicken/Lamb/Pork/Fish/Prawn Kottu",
			price: "$ 20.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Seafood (Fish, Prawn & Squid) Kottu ",
			price: "$ 23.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Mix (Seafood & Chicken) Kottu",
			price: "$ 25.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Sri Lankan special Dolphin (Chicken/Lamb/Pork/Fish/Prawn) Kottu",
			price: "$ 23.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Mix Dolphin (Seafood & Chicken) Kottu",
			price: "$ 25.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Vegetable String Hopper Kottu",
			price: "$ 18.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Chicken/Lamb/Pork/Fish/Egg String Hopper Kottu",
			price: "$ 20.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Seafood (Fish, Prawn & Squid) String Hopper Kottu ",
			price: "$ 23.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Mix (Seafood & Chicken) String Hopper Kottu",
			price: "$ 25.00",
			// tags: "IE | 750 ml",
		},
		
	],
Nasi_Goreng: [
		{
			title: "Nasi Goreng (Chicken/Lamb/Pork/Fish/Egg)",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Seafood Nasi Goreng (Fish,Prawns & Squid) ",
			price: "$ 23.00",
			// tags: "AU | Bottle",
		},
		{	
			title: "Mix Seafood Nasi Goreng (Seafood & Chicken)",
			price: "$ 25.00",
			// tags: "AU | 750 ml",	
		},
	],

Biriyani: [
		{
			title: "Vegetable Biriyani",
			price: "$ 15.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Chicken Biriyani",
			price: "$ 17.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Lamb Biriyani",
			price: "$ 17.00",
			// tags: "FR | 750 ml",
		},
	],

Noodles : [
 	{
			title: "Egg & Vegetable Noodles",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Noodles (Chicken/Lamb/Pork/Fish/Egg)",
			price: "$ 18.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Seafood Noodles (Fish,Prawns & Squid) ",
			price: "$ 23.00",
			// tags: "AU | Bottle",
		},
		{	
			title: "Mix Seafood Noodles (Seafood & Chicken)",
			price: "$ 25.00",
			// tags: "AU | 750 ml",	
		},
	],

Hoppers_and_String_Hoppers : [
	{
			title: "Plain Hopper",
			price: "$ 3.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Egg Hopper",
			price: "$ 4.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Milk Hoppers",
			price: "$ 4.00",
			// tags: "FR | 750 ml",	
		},
		{
			title: "5 String Hoppers with any meat curry, Pol sambol and any vegetable curry",
			price: "$ 15.00",
			// tags: "CA | 750 ml",
		},
	],			
Roti_and_Paratha : [
 	{
			title: "Plain Roti",
			price: "$ 3.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Egg Roti",
			price: "$ 8.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Curry Roti",
			price: "$ 12.00",
			// tags: "AU | Bottle",
		},
		{	
			title: "3 Pol Roti with Lunumiris and 1 meat curry",
			price: "$ 15.00",
			// tags: "AU | 750 ml",	
		},
		{	
			title: "2 Parata with 1 meat curry and 1 vegetable curry",
			price: "$ 14.00",
			// tags: "AU | 750 ml",	
		},
	],
Curries: [
		{
			title: "Pork Curry",
			price: "$ 13.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Pork Curry (Large)",
			price: "$ 24.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Chicken Curry",
			price: "$ 12.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Chicken Curry (Large)",
			price: "$ 24.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Fish Curry",
			price: "$ 12.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Fish Curry (Large)",
			price: "$ 24.00",
		},
		{
			title: "Crab Curry (Large)",
			price: "$ 26.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Vege Curry",
			price: "$ 10.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Vege Curry (Large)",
			price: "$ 18.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Pork Stu",
			price: "$ 14.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Pork Stu (Large)",
			price: "$ 25.00",
		},
		{
			title: "Lamb Stu",
			price: "$ 14.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Lamb Stu (Large)",
			price: "$ 25.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Cuttle Fish Curry",
			price: "$ 15.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Cuttle Fish Curry (Large)",
			price: "$ 30.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Fried Fish",
			price: "$ 8.00",
			// tags: "IE | 750 ml",
		},
	],
	
others: [
		{
			title: "Chicken Thukpa",
			price: "Rs 200",
			// tags: "AU | Bottle",
		},
		{
			title: "Mis Thukpa",
			price: "Rs 275",
			// tags: "AU | Bottle",
		},
		{
			title: "Veg Thukpa",
			price: "Rs 170",
			// tags: "FR | 750 ml",
		},
		{
			title: "Aalo Paratha",
			price: "Rs 70",
			// tags: "CA | 750 ml",
		},
		{
			title: "Keema Paratha",
			price: "Rs 150",
			// tags: "IE | 750 ml",
		},
		{
			title: "Chicken Chowmein | Fry Rice",
			price: "Rs 200",
			// tags: "IE | 750 ml",
		},
		{
			title: "Mixed Chowmein | Fry Rice",
			price: "Rs 275",
			// tags: "IE | 750 ml",
		},
		{
			title: "Egg Chowmein | Fry Rice",
			price: "Rs 180",
			// tags: "IE | 750 ml",
		},
		{
			title: "Veg Chowmein | Fry Rice",
			price: "Rs 150",
			// tags: "IE | 750 ml",
		},
		{
			title: "Chicken Keema Noodle",
			price: "Rs 250",
			// tags: "IE | 750 ml",
		},
	],
	Bakery_Items : [
		{
			title: "Roast Bread (Boiled/Roasted)",
			price: "$ 3.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Fish Bun",
			price: "$ 4.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Jack Fruit Bun",
			price: "$ 4.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Seeni Sambol Bun",
			price: "$ 4.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Kimbula Bun",
			price: "$ 4.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Jam Bun",
			price: "$ 4.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Tea Bun",
			price: "$ 3.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Sugar Bun",
			price: "$ 3.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lavariya",
			price: "$ 4.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Pan Cake",
			price: "$ 4.00",
			// tags: "IE | 750 ml",
		},
	],


    Sri_Lankan_Sweeets_and_Desserts : [
		{
			title: "Watalappan",
			price: "$ 8.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Kiri Pani",
			price: "$ 7.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Ice Cream (Vanila/Chocolate)",
			price: "$ 6.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Milk Toffee (4 pieces)",
			price: "$ 4.80",
			// tags: "CA | 750 ml",
		},
		{
			title: "Coconut Toffee (4 pieces)",
			price: "$ 4.80",
			// tags: "CA | 750 ml",
		},
		{
			title: "Broken Jelly",
			price: "$ 6.00",
			// tags: "IE | 750 ml",
		},
		{
			title: "Rainbow Jelly",
			price: "$ 6.00",
			// tags: "IE | 750 ml",
		},

	],

    steam: [
		{
			title: "Chicken",
			price: "$ 12.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Pepper Dishes (Chicken/Lamb/Pork)",
			price: "$ 13.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Fish",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lamb",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Pork)",
			price: "$ 12.00",
			// tags: "CA | 750 ml",
		},
	],
	fried: [
		{
			title: "Chicken",
			price: "$ 23.50",
			// tags: "AU | Bottle",
		},
		{
			title: "Prawn",
			price: "$ 30.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Hot Butter Cuttlefish (Dry/Gravy)",
			price: "$ 28.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Pepper Dishes (Chicken/Lamb/Pork)",
			price: "$ 26.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Fish",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Lamb",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Pork)",
			price: "$ 23.00",
			// tags: "CA | 750 ml",
		},
	],
	cold: [
		{
			title: "Soft Drink & Water",
			price: "$ 4.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Faluda (without Ice Cream)",
			price: "$ 3.00",
			// tags: "AU | Bottle",
		},
		{
			title: "Faluda (with Ice Cream)",
			price: "$ 8.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Mango Lassi",
			price: "$ 6.50",
			// tags: "CA | 750 ml",
		},
		{
			title: "Coconut Water",
			price: "$ 6.50",
			// tags: "CA | 750 ml",
		},
		{
			title: "Ice Milo",
			price: "$ 3.50",
			// tags: "CA | 750 ml",
		},
		{
			title: "Ice Coffee",
			price: "$ 6.50",
			// tags: "IE | 750 ml",
		},
	
	],
	hot: [
		{
			title: "Ginger Plain Tea",
			price: "$ 3.50",
			// tags: "AU | Bottle",
		},
		{
			title: "Milk Tea",
			price: "$ 3.50",
			// tags: "AU | Bottle",
		},
		{
			title: "Plain Tea",
			price: "$ 3.00",
			// tags: "FR | 750 ml",
		},
		{
			title: "Masala Tea",
			price: "$ 3.50",
			// tags: "CA | 750 ml",
		},
		{
			title: "Harischandra Coffee",
			price: "$ 5.00",
			// tags: "CA | 750 ml",
		},
		{
			title: "Nescafe",
			price: "$ 6.50",
			// tags: "IE | 750 ml",
		},
	],
};
